import { render, staticRenderFns } from "./session-details-table.vue?vue&type=template&id=50ec2186&"
import script from "./session-details-table.vue?vue&type=script&lang=js&"
export * from "./session-details-table.vue?vue&type=script&lang=js&"
import style0 from "./session-details-table.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports